import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { API_URLS } from '@core/api-url.enum';
import { ApiCallService } from '@services/api-call.service';
import { RESOURCE_TYPE } from '@modules/resources/components/resources-container/contant';
import { Application } from '@enums/application.enums';
import { CommonService } from '@shared/services/common.service';

interface ResourceCount {
  total_count: number;
  unread_count: number;
}

const EMPTY_COUNT: ResourceCount = { total_count: 0, unread_count: 0 };

@Injectable({
  providedIn: 'root',
})
export class ResourcesService implements OnDestroy {
  private destroy$ = new Subject<void>();

  private announcementsCountSubject = new BehaviorSubject<ResourceCount>(EMPTY_COUNT);
  announcementsCount$ = this.announcementsCountSubject.asObservable();

  private tipsTutorialsCountSubject = new BehaviorSubject<ResourceCount>(EMPTY_COUNT);
  tipsTutorialsCount$ = this.tipsTutorialsCountSubject.asObservable();

  constructor(private apiCallService: ApiCallService, private cs: CommonService) {}

  fetchResourcesCount() {
    this.apiCallService
      .get(API_URLS.resourcesCount, false)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const data = res?.data || [];
          let announcementCount = { ...EMPTY_COUNT };
          let tipsCount = { ...EMPTY_COUNT };

          data.forEach((item: any) => {
            if (item?.type === RESOURCE_TYPE.ANNOUNCEMENT) {
              announcementCount = {
                total_count: item?.total_count || Application.ZERO,
                unread_count: item?.unread_count || Application.ZERO
              };
            } else if (item?.type === RESOURCE_TYPE.TIPS_TUTORIALS) {
              tipsCount = {
                total_count: item?.total_count || Application.ZERO,
                unread_count: item?.unread_count || Application.ZERO
              };
            }
          });

          this.announcementsCountSubject.next(announcementCount);
          this.tipsTutorialsCountSubject.next(tipsCount);
          this.cs.totalUnreadResourcesCountSubject.next(
            announcementCount.unread_count + tipsCount.unread_count
          );
          this.cs
        },
        error: () => {
          this.announcementsCountSubject.next(EMPTY_COUNT);
          this.tipsTutorialsCountSubject.next(EMPTY_COUNT);
          this.cs.totalUnreadResourcesCountSubject.next(Application.ZERO);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}